import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, BuildingIcon, GlassWaterIcon, ChefHatIcon } from 'lucide-react';
export function FacilityBookingExcerpt({
  onViewMore
}: {
  onViewMore: () => void;
}) {
  return <section className="w-full bg-[#050505] py-24 px-6 relative border-t border-[#C9A84C]/10" data-id="element-16">
      <div className="max-w-7xl mx-auto" data-id="element-17">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-18">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-19">
            <span className="font-inter text-xs tracking-[0.4em] text-[#C9A84C]/70 uppercase" data-id="element-20">
              Private Events
            </span>
            <h2 className="font-montserrat font-black text-4xl sm:text-5xl tracking-widest text-white mt-2 mb-6" data-id="element-21">
              FACILITY BOOKING
            </h2>
            <div className="w-16 h-px bg-[#C9A84C]/50 mb-6" data-id="element-22" />
            <p className="font-inter font-light text-white/60 text-lg leading-relaxed mb-8" data-id="element-23">
              MK Lounge DC is a modern lounge with 2 floors. With 2 fully
              stocked bars, one on each floor, we are equipped to handle most
              events including corporate gatherings. We also feature a full
              kitchen to cater to your guests' needs.
            </p>
            <button onClick={onViewMore} className="group flex items-center gap-3 font-montserrat font-700 text-xs tracking-widest bg-[#C9A84C] text-[#050505] px-8 py-4 rounded-xl hover:bg-[#E8C97A] transition-all duration-300" style={{
            boxShadow: '0 4px 20px rgba(201,168,76,0.2)'
          }} data-id="element-24">
              VIEW DETAILS
              <ArrowRightIcon size={14} className="group-hover:translate-x-1 transition-transform" data-id="element-25" />
            </button>
          </motion.div>

          {/* Visual / Features Grid */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-26">
            {[{
            icon: <BuildingIcon size={24} data-id="element-27" />,
            title: '2 FLOORS',
            desc: 'Spacious modern layout'
          }, {
            icon: <GlassWaterIcon size={24} data-id="element-28" />,
            title: '2 BARS',
            desc: 'Fully stocked on each level'
          }, {
            icon: <ChefHatIcon size={24} data-id="element-29" />,
            title: 'FULL KITCHEN',
            desc: 'Complete catering available'
          }, {
            icon: <BuildingIcon size={24} data-id="element-30" />,
            title: 'ANY EVENT',
            desc: 'Perfect for corporate events'
          }].map((feature, idx) => <div key={idx} className="bg-[#0a0a0a] border border-[#C9A84C]/20 rounded-2xl p-6 hover:border-[#C9A84C]/50 transition-colors group" data-id="element-31">
                <div className="w-12 h-12 rounded-xl bg-[#C9A84C]/10 flex items-center justify-center text-[#C9A84C] mb-4 group-hover:scale-110 transition-transform" data-id="element-32">
                  {feature.icon}
                </div>
                <h3 className="font-montserrat font-black text-sm tracking-widest text-white mb-1" data-id="element-33">
                  {feature.title}
                </h3>
                <p className="font-inter text-xs text-white/50" data-id="element-34">
                  {feature.desc}
                </p>
              </div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}